function showTab(prevIdx, nextIdx) {
    if(prevIdx >= 0) {
        const prev = document.querySelector(`[data-tabContent='${prevIdx}']`);
        prev.classList.remove('active-tab');
    }
    const next = document.querySelector(`[data-tabContent='${nextIdx}']`);
    next.classList.add('active-tab');
}

(() => {
    document.addEventListener('DOMContentLoaded', (event) => {
        let prevIdx = 0;
        const tabs = document.querySelectorAll('[data-tab]');
        tabs.forEach(tab => {
            tab.addEventListener('click', (event) => {
                if(prevIdx >= 0) {
                    const prev = document.querySelector(`[data-tab='${prevIdx}']`);
                    prev.classList.remove('active-tab-switch');
                }
                event.target.classList.add('active-tab-switch');

                showTab(prevIdx, event.target.dataset.tab);
                prevIdx = event.target.dataset.tab;
            });
        })
    })
})();